import React, { useEffect, useContext, useState,useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  customStyle,
  getSystemSettings,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { useReactToPrint } from "react-to-print";
import { Helmet } from "react-helmet";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Moment from "react-moment";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import { MdDelete } from 'react-icons/md';
// import StockReport from "./StockReport";

//pages & includes
import AccountsSidebar from "../AccountsSidebar";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const ProfitAndLossReport = () => {
  const { t } = useTranslation();
  let { loading, setLoading, generalSettings } = useContext(SettingsContext);
  const { branchForSearch } = useContext(RestaurantContext);
  const { authUserInfo } = useContext(UserContext);
  
  //toast obj
  let common_toast={
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  }

  const [siteName, setSiteName] = useState("");

  //reportFields state
  const [reportFields,setReportFields]=useState({
    from_date:"",
    to_date:"",
  });
  const [option,setOption] = useState("view");

  //report states
  const [reportData, setReportData] = useState([]);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [viewReport, setViewReport] = useState(false);

  const componentRef = useRef();
  const componentRefThermal = useRef();

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));
  },[generalSettings]);

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
  });

  const handleFromDate=(from_date)=>{
    setReportFields({
      ...reportFields,
      from_date
    })
  }

  const handleOption  = (e) =>{
    setOption(e.target.value)
  }

  const handleToDate=(to_date)=>{
    setReportFields({
      ...reportFields,
      to_date
    })
  }

  const handleBranch=(branch)=>{
    setReportFields({
      ...reportFields,
      branch
    })
  }

  const handleSubmit=(e)=>{
    e.preventDefault();
    setViewReport(false);
    let {from_date, to_date, branch } = reportFields;
    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      !branch?.[0]?.id
    ) {
      toast.error(`${_t(t("Please select branch"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }
    if((from_date !== "" && from_date !== null) && (to_date !== "" && to_date !== null)){
      // setLoading(true);
      const url = BASE_URL + "/settings/get-profit-loss-report";
      const branh = branch && branch?.length ? JSON.stringify(branch.map(item=>item.id)) : ""; 
      let formData = new FormData();
      formData.append('from_date', moment(from_date).format("YYYY-MM-DD"));
      formData.append('to_date', moment(to_date).format("YYYY-MM-DD"));
      formData.append('branch_id', branh);
      
      return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setReportData(res.data);
        if(option==="excel"){
          setGeneratedReport(true);
          componentRef.current.handleDownload(); 
        }else if(option === "view"){
          setViewReport(true)
        }else{
          setGeneratedReport(true);
          thermalPrint();
        }                              
        setLoading(false);
      })
      .catch((error) => {            
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`,common_toast);
      });
      
    }else{
      toast.error(`${_t(t("Please select from date & to date"))}`,common_toast);
    }
  }
  
  let revenue = 0;
  let costGoods = 0;
  let otherIncome = 0;
  let expense = 0;

  let revenue1 = 0;
  let costGoods1 = 0;
  let otherIncome1 = 0;
  let expense1 = 0;

  let revenue2 = 0;
  let costGoods2 = 0;
  let otherIncome2 = 0;
  let expense2 = 0;

  return (
    <>
    <Helmet>
      <title>{_t(t("Accounts Profit And Loss Report"))}</title>
    </Helmet>

    <ReactHTMLTableToExcel
      id="test-table-xls-button"
      className="download-table-xls-button btn btn-success float-right mr-3 invisible"
      table="table-to-xls"
      filename="Accounts Profit And Loss Report"
      sheet="sheet 1"
      buttonText="Report"
      ref={componentRef}
    />

    {/* Print Button */}
    <div className="d-none">
      <div>
        <div className="fk-print">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {
                reportData !== null &&
                  reportData !== undefined &&
                  generatedReport === true && 
                  (
                    <>
                      <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                        <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                          <table
                            className="table table-bordered table-hover min-table-height mt-3"
                            id="table-to-xls"
                          >
                            <div className="page-break"></div>
                            <thead className="align-middle">
                              <tr style={{ border: "0px" }}>
                                <th colspan="3" style={{ border: "0px" }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <h3 className="text-center mb-0">
                                        {siteName}
                                      </h3>
                                      <h3 className="text-center mt-0">
                                        Accounts Profit And Loss Report
                                      </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {reportFields.from_date}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{reportFields.to_date}</Moment>
                                        </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th
                                  scope="col"
                                  className="sm-table text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("S/L"))}
                                </th>
                                
                                <th
                                  scope="col"
                                  className="sm-table text-capitalize align-middle text-center border-1 border"
                                >
                                {_t(t("Account"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-table text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Amount"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here*/}
                              <tr>
                                <th colSpan={2}>Revenue</th>
                              </tr>
                              {
                                reportData[0] && reportData[0]?.length ? reportData[0].map((item,i)=>{
                                  revenue += Number(item.balance);
                                  return(
                                    <tr>
                                      <td>{i+1}</td>
                                      <td>{item.level1_code + "-" + item.level2_code + "-" + item.level3_code + "-" + item.level3_display_nam}</td>
                                      <td>{item.balance}</td>
                                    </tr>
                                  )
                                }) : ""
                              }
                              <tr>
                                <th></th>
                                <th>Total</th>
                                <th>{formatPrice(revenue)}</th>
                              </tr>
                              <tr></tr>
                              <tr>
                                <th colSpan={2}>Cost Of Good Sold</th>
                              </tr>
                              {
                                reportData[1] && reportData[1]?.length ? reportData[1].map((item,i)=>{
                                  costGoods += Number(item.balance);
                                  return(
                                    <tr>
                                      <td>{i+1}</td>
                                      <td>{item.level1_code + "-" + item.level2_code + "-" + item.level3_code + "-" + item.level3_display_nam}</td>
                                      <td>{item.balance}</td>
                                    </tr>
                                  )
                                }) : ""
                              }
                              <tr>
                                <th></th>
                                <th>Total</th>
                                <th>{formatPrice(costGoods)}</th>
                              </tr>
                              <tr>
                                <th></th>
                                <th>Gross Profit</th>
                                <th>{formatPrice(revenue - costGoods)}</th>
                              </tr>
                              <tr></tr>
                              <tr>
                                <th colSpan={2}>Other Income</th>
                              </tr>
                              {
                                reportData[3] && reportData[3]?.length ? reportData[3].map((item,i)=>{
                                  otherIncome += Number(item.balance);
                                  return(
                                    <tr>
                                      <td>{i+1}</td>
                                      <td>{item.level1_code + "-" + item.level2_code + "-" + item.level3_code + "-" + item.level3_display_nam}</td>
                                      <td>{item.balance}</td>
                                    </tr>
                                  )
                                }) : ""
                              }
                              <tr>
                                <th></th>
                                <th>Total</th>
                                <th>{otherIncome < 0 ? `(${formatPrice(otherIncome)})` : formatPrice(otherIncome)}</th>
                              </tr>
                              <tr>
                                <th></th>
                                <th>Gross After Other Income</th>
                                <th>{formatPrice(revenue + (otherIncome < 0 ? (otherIncome * -1) : otherIncome) - costGoods)}</th>
                              </tr>
                              <tr></tr>
                              <tr>
                                <th colSpan={2}>Expense</th>
                              </tr>
                              {
                                reportData[2] && reportData[2]?.length ? reportData[2].map((item,i)=>{
                                  expense += Number(item.balance);
                                  return(
                                    <tr>
                                      <td>{i+1}</td>
                                      <td>{item.level1_code + "-" + item.level2_code + "-" + item.level3_code + "-" + item.level3_display_nam}</td>
                                      <td>{item.balance}</td>
                                    </tr>
                                  )
                                }) : ""
                              }
                              <tr>
                                <th></th>
                                <th>Total Expense</th>
                                <th>{formatPrice(expense)}</th>
                              </tr>
                              <tr>
                                <th></th>
                                <th>Net Income</th>
                                <th>{formatPrice(revenue + (otherIncome < 0 ? (otherIncome * -1) : otherIncome) - costGoods - expense)}</th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* thermal print */}
    <div className="d-none">
      <div ref={componentRefThermal} className="mx-4">
        {          
          <div className="fk-print">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true &&  (
                    <table className="table table-bordered mt-4 mx-2 fk-print-text_pos">
                      <thead className="align-middle sm-text">
                        <tr style={{ border: "0px" }}>
                          <th colspan="12" style={{ border: "0px" }}>
                            <div className="row">
                              <h3 className="text-center mb-0">
                                {siteName}
                              </h3>
                              <h3 className="mt-2 font-weight-bold text-uppercase text-center table-text">
                                Profit and Loss
                              </h3>
                              <div>
                                <p className="mt-1 mb-0 font-weight-bold text-uppercase text-center table-text">
                                  FROM&nbsp;
                                  <Moment format="LL">
                                  {reportFields.from_date}
                                  </Moment>
                                  &nbsp;TO&nbsp;
                                  <Moment format="LL">{reportFields.to_date}</Moment>
                                </p>
                              </div>
                            </div> 
                          </th>
                        </tr>  
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border " >S/L</th>
                          <th className="text-capitalize align-middle text-center border-1 border " >Account</th>
                          <th className="text-capitalize align-middle text-center border-1 border " >Amount</th>
                        </tr>       
                      </thead>
                      <tbody className="align-middle sm-text"> 
                        <tr>
                          <th 
                          className="text-capitalize align-middle text-center border-1 border"
                          colSpan={2}
                          >Revenue</th>
                        </tr>
                        {
                          reportData[0] && reportData[0]?.length ? reportData[0].map((item,i)=>{
                            revenue1 += Number(item.balance);
                            return(
                              <tr>
                                <td className="text-capitalize align-middle text-center border-1 border" >{i+1}</td>
                                <td className="text-capitalize align-middle text-center border-1 border" >{item.level1_code + "-" + item.level2_code + "-" + item.level3_code + "-" + item.level3_display_nam}</td>
                                <td className="text-capitalize align-middle text-center border-1 border" >{item.balance}</td>
                              </tr>
                            )
                          }) : ""
                        }
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border"></th>
                          <th className="text-capitalize align-middle text-center border-1 border">Total</th>
                          <th className="text-capitalize align-middle text-center border-1 border">{formatPrice(revenue1)}</th>
                        </tr>
                        <tr></tr>
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border" colSpan={2}>Cost Of Good Sold</th>
                        </tr>
                        {
                          reportData[1] && reportData[1]?.length ? reportData[1].map((item,i)=>{
                            costGoods1 += Number(item.balance);
                            return(
                              <tr>
                                <td className="text-capitalize align-middle text-center border-1 border" >{i+1}</td>
                                <td className="text-capitalize align-middle text-center border-1 border">{item.level1_code + "-" + item.level2_code + "-" + item.level3_code + "-" + item.level3_display_nam}</td>
                                <td className="text-capitalize align-middle text-center border-1 border">{item.balance}</td>
                              </tr>
                            )
                          }) : ""
                        }
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border"></th>
                          <th className="text-capitalize align-middle text-center border-1 border">Total</th>
                          <th className="text-capitalize align-middle text-center border-1 border">{formatPrice(costGoods1)}</th>
                        </tr>
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border"></th>
                          <th className="text-capitalize align-middle text-center border-1 border">Gross Profit</th>
                          <th className="text-capitalize align-middle text-center border-1 border">{formatPrice(revenue1 - costGoods1)}</th>
                        </tr>
                        <tr></tr>
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border" colSpan={2}>Other Income</th>
                        </tr>
                        {
                          reportData[3] && reportData[3]?.length ? reportData[3].map((item,i)=>{
                            otherIncome1 += Number(item.balance);
                            return(
                              <tr>
                                <td className="text-capitalize align-middle text-center border-1 border" >{i+1}</td>
                                <td className="text-capitalize align-middle text-center border-1 border">{item.level1_code + "-" + item.level2_code + "-" + item.level3_code + "-" + item.level3_display_nam}</td>
                                <td className="text-capitalize align-middle text-center border-1 border">{item.balance}</td>
                              </tr>
                            )
                          }) : ""
                        }
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border"></th>
                          <th className="text-capitalize align-middle text-center border-1 border">Total</th>
                          <th className="text-capitalize align-middle text-center border-1 border">{otherIncome1 < 0 ? `(${formatPrice(otherIncome1)})` : formatPrice(otherIncome1)}</th>
                        </tr>
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border"></th>
                          <th className="text-capitalize align-middle text-center border-1 border">Gross After Other Income</th>
                          <th className="text-capitalize align-middle text-center border-1 border">{formatPrice(revenue1 + (otherIncome1 < 0 ? (otherIncome1 * -1) : otherIncome1) - costGoods1)}</th>
                        </tr>
                        <tr></tr>
                        <tr>
                          <th
                          className="text-capitalize align-middle text-center border-1 border"
                          colSpan={2}>Expense</th>
                        </tr>
                        {
                          reportData[2] && reportData[2]?.length ? reportData[2].map((item,i)=>{
                            expense1 += Number(item.balance);
                            return(
                              <tr>
                                <td className="text-capitalize align-middle text-center border-1 border">{i+1}</td>
                                <td className="text-capitalize align-middle text-center border-1 border">{item.level1_code + "-" + item.level2_code + "-" + item.level3_code + "-" + item.level3_display_nam}</td>
                                <td className="text-capitalize align-middle text-center border-1 border">{item.balance}</td>
                              </tr>
                            )
                          }) : ""
                        }
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border"></th>
                          <th className="text-capitalize align-middle text-center border-1 border">Total Expense</th>
                          <th className="text-capitalize align-middle text-center border-1 border">{formatPrice(expense1)}</th>
                        </tr>
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border"></th>
                          <th className="text-capitalize align-middle text-center border-1 border">Net Income</th>
                          <th className="text-capitalize align-middle text-center border-1 border">{formatPrice(revenue1 + (otherIncome1 < 0 ? (otherIncome1 * -1) : otherIncome1) - costGoods1 - expense1)}</th>
                        </tr>                           
                      </tbody>
                    </table>
                  )}
                </div> 
              </div> 
            </div> 
          </div>           
        }
      </div> 
    </div> 

    {/* main body */}
    <main id="main" data-simplebar>
      <div className="container-fluid">
        <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <AccountsSidebar />
          </div>
          {/* left Sidebar ends */}

          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
            <div className="t-bg-white">
              <div
                className="fk-scroll--pos-menu table-bottom-info-hide"
                data-simplebar
              >
                <div className="t-pl-15 t-pr-15">
                  {/* next page data spin loading */}
                  <CustomSpinLoader loading={loading}/>
                  {/* spin loading ends */}

                  <div key="fragment-3">
                    <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                      <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                        <ul className="t-list fk-breadcrumb">
                          <li className="fk-breadcrumb__list">
                            <span className="t-link fk-breadcrumb__link text-capitalize">
                            {_t(t("Profit And Loss Report"))}
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6 col-lg-7 d-flex justify-content-end p-0">
                        <div className="d-inline mr-3 d-flex align-items-center">
                          <input
                            type="radio"
                            className="form-check-input pointer-cursor"
                            id="view"
                            name="view"
                            value="view"
                            onChange={(e) => {
                              handleOption(e);
                            }}
                            checked={
                              option === "view"
                            }
                          />
                          <label
                            className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                            htmlFor="view"
                            style={{fontSize:"16px",borderRadius:"5px"}}
                          >
                            <i className="fa fa-eye" aria-hidden="true"></i> {_t(t("View"))}
                          </label>
                        </div>
                        <div className="d-inline mr-3 d-flex align-items-center">
                          <input
                            type="radio"
                            className="form-check-input pointer-cursor"
                            id="excel_report"
                            name="excel_report"
                            value="excel"
                            onChange={(e) => {
                              handleOption(e);
                            }}
                            checked={
                              option === "excel"
                            }
                          />
                          <label
                            className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                            htmlFor="excel_report"
                            style={{fontSize:"16px",borderRadius:"5px"}}
                          >
                            <i className="fa fa-table" aria-hidden="true"></i> {_t(t("Excel"))}
                          </label>
                        </div>

                        <div className="d-inline mr-2 d-flex align-items-center">
                          <input
                            type="radio"
                            className="form-check-input pointer-cursor"
                            id="print_report"
                            name="print_report"
                            value="print"
                            onChange={(e) => {
                              handleOption(e);
                            }}
                            checked={
                              option === "print"
                            }
                          />
                          <label
                            className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                            htmlFor="print_report"
                            style={{fontSize:"16px",borderRadius:"5px"}}
                          >
                            <i className="fa fa-print" aria-hidden="true"></i> {_t(t("Print"))}
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Form starts here */}
                    <div className="card mx-1 px-2 pb-1">
                      <form
                      className="row p-1 mx-0 mb-3 table-text"
                      onSubmit={handleSubmit}
                      >
                        <div className="col-12">
                          <div>                            
                            <div className="row">
                              <div className="form-group col-3 text-right mt-2">
                                <div className="mb-2 text-left">
                                  <label
                                  htmlFor="fromDate"
                                  className="control-label"
                                  >
                                  {_t(t("From Date"))}
                                  <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <DatePicker
                                  selected={reportFields.from_date}
                                  onChange={(date) => handleFromDate(date)}
                                  maxDate={new Date()}
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control table-text d-block"
                                  placeholderText={_t(t("From Date"))}
                                  shouldCloseOnSelect={false}                                  
                                />
                              </div>

                              <div className="form-group col-3 text-right mt-2">
                                <div className="mb-2 text-left">
                                  <label
                                  htmlFor="toDate"
                                  className="control-label"
                                  >
                                  {_t(t("To Date"))}
                                  <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <DatePicker
                                  selected={reportFields.to_date}
                                  onChange={(date) => handleToDate(date)}
                                  maxDate={new Date()}
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control table-text d-block"
                                  placeholderText={_t(t("To Date"))}
                                  shouldCloseOnSelect={false}                                  
                                />
                              </div>

                              <div className="form-group mt-2 col-3">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="transaction"
                                    className="control-label"
                                  >
                                    {_t(t("Branch"))}                                  
                                  </label>
                                </div>
                                <Select
                                  options={branchForSearch ? branchForSearch : []}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={reportFields.branch || ""}
                                  classNamePrefix="select table-text"
                                  onChange={(branch)=>handleBranch(branch)} 
                                  isClearable 
                                  isMulti                            
                                  placeholder={
                                    _t(t("Please select branch")) + ".."
                                  }
                                  styles={customStyle}
                                />
                              </div>

                              <div className="form-group mt-2 col-1">
                              </div>
                          
                              <div className="form-group mt-4 col-2" style={{textAlign:"right"}}>                                                                                                                        
                                <button
                                disabled={loading}
                                type="submit"
                                className="btn btn-primary rounded mt-2"
                                >
                                  {_t(t("Print P&L"))}
                                </button>                                                                                                                                                                                       
                              </div>
                            </div>
                          </div>                                                                        
                        </div>
                      </form>
                      
                      {reportData !== null &&
                        reportData !== undefined &&
                        viewReport === true &&  (
                        <div className="col-12 t-mb-15 mb-md-0 bill_modal_scroll" style={{height: "calc(100vh - 18.1rem)"}} >
                          <table className="table table-bordered my-1">
                            <thead className="align-middle table-text">
                              <tr style={{position: "sticky", top: "-0.1px", backgroundColor: "white"}}>
                                <th className="text-capitalize align-middle text-center border-1 border " >S/L</th>
                                <th className="text-capitalize align-middle text-center border-1 border " >Account</th>
                                <th className="text-capitalize align-middle text-center border-1 border " >Amount</th>
                              </tr>       
                            </thead>
                            <tbody className="align-middle table-text"> 
                              <tr>
                                <th 
                                className="text-capitalize align-middle text-center border-1 border"
                                colSpan={2}
                                >Revenue</th>
                              </tr>
                              {
                                reportData[0] && reportData[0]?.length ? reportData[0].map((item,i)=>{
                                  revenue2 += Number(item.balance);
                                  return(
                                    <tr>
                                      <td className="text-capitalize align-middle text-center border-1 border" >{i+1}</td>
                                      <td className="text-capitalize align-middle text-center border-1 border" >{item.level1_code + "-" + item.level2_code + "-" + item.level3_code + "-" + item.level3_display_nam}</td>
                                      <td className="text-capitalize align-middle text-center border-1 border" >{item.balance}</td>
                                    </tr>
                                  )
                                }) : ""
                              }
                              <tr>
                                <th className="text-capitalize align-middle text-center border-1 border"></th>
                                <th className="text-capitalize align-middle text-center border-1 border">Total</th>
                                <th className="text-capitalize align-middle text-center border-1 border">{formatPrice(revenue2)}</th>
                              </tr>
                              <tr></tr>
                              <tr>
                                <th className="text-capitalize align-middle text-center border-1 border" colSpan={2}>Cost Of Good Sold</th>
                              </tr>
                              {
                                reportData[1] && reportData[1]?.length ? reportData[1].map((item,i)=>{
                                  costGoods2 += Number(item.balance);
                                  return(
                                    <tr>
                                      <td className="text-capitalize align-middle text-center border-1 border" >{i+1}</td>
                                      <td className="text-capitalize align-middle text-center border-1 border">{item.level1_code + "-" + item.level2_code + "-" + item.level3_code + "-" + item.level3_display_nam}</td>
                                      <td className="text-capitalize align-middle text-center border-1 border">{item.balance}</td>
                                    </tr>
                                  )
                                }) : ""
                              }
                              <tr>
                                <th className="text-capitalize align-middle text-center border-1 border"></th>
                                <th className="text-capitalize align-middle text-center border-1 border">Total</th>
                                <th className="text-capitalize align-middle text-center border-1 border">{formatPrice(costGoods2)}</th>
                              </tr>
                              <tr>
                                <th className="text-capitalize align-middle text-center border-1 border"></th>
                                <th className="text-capitalize align-middle text-center border-1 border">Gross Profit</th>
                                <th className="text-capitalize align-middle text-center border-1 border">{formatPrice(revenue2 - costGoods2)}</th>
                              </tr>
                              <tr></tr>
                              <tr>
                                <th className="text-capitalize align-middle text-center border-1 border" colSpan={2}>Other Income</th>
                              </tr>
                              {
                                reportData[3] && reportData[3]?.length ? reportData[3].map((item,i)=>{
                                  otherIncome2 += Number(item.balance);
                                  return(
                                    <tr>
                                      <td className="text-capitalize align-middle text-center border-1 border" >{i+1}</td>
                                      <td className="text-capitalize align-middle text-center border-1 border">{item.level1_code + "-" + item.level2_code + "-" + item.level3_code + "-" + item.level3_display_nam}</td>
                                      <td className="text-capitalize align-middle text-center border-1 border">{item.balance}</td>
                                    </tr>
                                  )
                                }) : ""
                              }
                              <tr>
                                <th className="text-capitalize align-middle text-center border-1 border"></th>
                                <th className="text-capitalize align-middle text-center border-1 border">Total</th>
                                <th className="text-capitalize align-middle text-center border-1 border">{otherIncome2 < 0 ? `(${formatPrice(otherIncome2)})` : formatPrice(otherIncome2)}</th>
                              </tr>
                              <tr>
                                <th className="text-capitalize align-middle text-center border-1 border"></th>
                                <th className="text-capitalize align-middle text-center border-1 border">Gross After Other Income</th>
                                <th className="text-capitalize align-middle text-center border-1 border">{formatPrice(revenue2 + (otherIncome2 < 0 ? (otherIncome2 * -1) : otherIncome2) - costGoods2)}</th>
                              </tr>
                              <tr></tr>
                              <tr>
                                <th
                                className="text-capitalize align-middle text-center border-1 border"
                                colSpan={2}>Expense</th>
                              </tr>
                              {
                                reportData[2] && reportData[2]?.length ? reportData[2].map((item,i)=>{
                                  expense2 += Number(item.balance);
                                  return(
                                    <tr>
                                      <td className="text-capitalize align-middle text-center border-1 border">{i+1}</td>
                                      <td className="text-capitalize align-middle text-center border-1 border">{item.level1_code + "-" + item.level2_code + "-" + item.level3_code + "-" + item.level3_display_nam}</td>
                                      <td className="text-capitalize align-middle text-center border-1 border">{item.balance}</td>
                                    </tr>
                                  )
                                }) : ""
                              }
                              <tr>
                                <th className="text-capitalize align-middle text-center border-1 border"></th>
                                <th className="text-capitalize align-middle text-center border-1 border">Total Expense</th>
                                <th className="text-capitalize align-middle text-center border-1 border">{formatPrice(expense2)}</th>
                              </tr>
                              <tr>
                                <th className="text-capitalize align-middle text-center border-1 border"></th>
                                <th className="text-capitalize align-middle text-center border-1 border">Net Income</th>
                                <th className="text-capitalize align-middle text-center border-1 border">{formatPrice(revenue2 + (otherIncome2 < 0 ? (otherIncome2 * -1) : otherIncome2) - costGoods2 - expense2)}</th>
                              </tr>                           
                            </tbody>
                          </table>
                        </div> 
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Rightbar contents end*/}
        </div>
      </div>
    </main>
    {/* main body ends */}
  </>
  )
}

export default ProfitAndLossReport;
